/*
 * Copyright © 2017-Present, The Freshwater Trust, all rights reserved.
 */

import {BaseFieldViewer} from "./BaseFieldViewer";
import autobind from "autobind-decorator";
import {service as HucService} from "../../../Services/HucService";

export class HucFieldViewer extends BaseFieldViewer {
	constructor(props) {
		super(props);

		this.setInitialState({
			hucs: []
		});
	}

	@autobind
	shouldReloadData(prevProps, prevState) {
		return this.props.Value != prevProps.Value;
	}

	@autobind
	loadData() {
		super.loadData();

		HucService.Get()
			.then((x) => {
				this.setState({hucs: x.result});
			});
	}

	@autobind
	getHuc() {
		return this.state.hucs.find((x) => x.hucId == this.props.Value);
	}

	@autobind
	_render() {
		let huc = this.getHuc();

		return huc ? (huc.hucCode + " (" + huc.name + ")") : "N/A";
	}
}